// src/components/Layout.js

import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useRfiListForFilters } from "../custom-hooks/useFiltersData-hooks";
import { setRFIs } from "../redux-store/features/rfisColors";
import { useAuth, useClerk, useUser } from "@clerk/clerk-react";
import Notification from "./Notification";
import MaintenanceBanner from "./MaintenanceBanner";
import {
  useCheckEmailConfirmed,
  useGetClientSecrets,
  useGetVendorsMe,
  useLoggedInGetSponsorUserDetails,
} from "../custom-hooks/queries";
import { useUserRole } from "../utils/helperMethods";
import { setLoggedInUserDetails } from "../redux-store/features/loggedInUserSlice";
import { setClientSecrets } from "../redux-store/features/clientSecretsSlice";

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const { user, isLoaded } = useUser();
  const role = user?.publicMetadata?.role;
  const isDrawerOpen = useSelector((state) => state.layout.drawerOpen);
  const { data: clientSecrets } = useGetClientSecrets();
  const { rfiListForFilters } = useRfiListForFilters();
  const { data: userDetails, isLoading: loads } =
    useLoggedInGetSponsorUserDetails(role);
  const { data: vendorUser } = useGetVendorsMe(role);

  const { isSignedIn } = useAuth();

  useEffect(() => {
    if (!isSignedIn) {
      sessionStorage.clear();
    }
  }, [isSignedIn]);

  useEffect(() => {
    if (clientSecrets && rfiListForFilters) {
      dispatch(setClientSecrets(clientSecrets));
      dispatch(setRFIs(rfiListForFilters));
      dispatch(setLoggedInUserDetails(userDetails));
    }
  }, [rfiListForFilters, clientSecrets, userDetails]);

  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const userRole = useUserRole();

  const { data, isLoading } = useCheckEmailConfirmed(role);

  const { signOut } = useClerk();

  // useEffect(() => {
  //   if (isLoading || data === undefined) return;

  //   if (["Backend User", "Backend Master User"].includes(role)) {
  //     const isVerified = data;
  //     if (isVerified === true) {
  //     } else {
  //       setMessage(
  //         "Your email is not verified. Please verify your email to continue."
  //       );
  //       setShowModal(true);
  //       setTimeout(() => {
  //         signOut();
  //       }, 2000);
  //     }
  //   }
  // }, [data]);

  return (
    <div
      className={`layout ${
        isDrawerOpen ? "backdrop-blur-sm backdrop-filter" : ""
      }`}
    >
      <div className="lg:ml-72">
        <MaintenanceBanner />
      </div>
      <Sidebar userDetails={userDetails} vendorUserRights={vendorUser} />
      <Notification
        show={showModal}
        setShow={setShowModal}
        status={"error"}
        errorMessage={message}
      />
      <main className="ml-0 min-w-0 lg:ml-72">
        <div className="mx-auto w-full min-w-0 max-w-full">
          <main className="flex w-full min-w-0 flex-wrap justify-center">{children}</main>
        </div>
      </main>
    </div>
  );
};

export default Layout;
